
/**
 * Keeps the `storefront_country` cart attribute equal to the country chosen in the header selector
 * (ISO code, exact case: "BH", "KW", ...). Used by checkout payment rules (e.g. hide COD for Bahrain
 * unless the attribute is "BH").
 *
 * 1. When the header country form is submitted, the attribute is written first, then the form is submitted.
 * 2. On every page load the attribute is compared with the active country and corrected if it differs
 *    (covers first visit, market redirects, stale carts).
 */
(function () {
  'use strict';

  if (window.storefrontCountry) return;

  var LOG_KEY = 'storefront-country:log';
  var TAG = '[storefront_country]';
  var config = null;

  function parseConfig() {
    var node = document.getElementById('storefront-country-config');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function rootPath() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function attributeName() {
    return (config && config.attribute) || 'storefront_country';
  }

  function remember(message) {
    try {
      sessionStorage.setItem(LOG_KEY, message);
    } catch (error) {}
  }

  function replayLog() {
    try {
      var message = sessionStorage.getItem(LOG_KEY);
      if (!message) return;
      sessionStorage.removeItem(LOG_KEY);
      console.log(TAG, message);
    } catch (error) {}
  }

  /**
   * Writes the attribute on the cart. Overwrites any previous value.
   */
  function setCountry(code) {
    var value = String(code || '').trim();
    if (!value) return Promise.resolve(null);

    var attributes = {};
    attributes[attributeName()] = value;

    return fetch(rootPath() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        return response.json().then(function (cart) {
          if (!response.ok) throw new Error(cart.description || cart.message || 'cart/update.js failed');
          return cart;
        });
      })
      .then(function (cart) {
        var saved = cart && cart.attributes ? cart.attributes[attributeName()] : undefined;
        console.log(TAG, 'saved on cart:', attributeName() + '=' + saved, '| cart attributes:', cart.attributes);
        return cart;
      })
      .catch(function (error) {
        console.warn(TAG, 'could not save ' + attributeName() + '=' + value, error);
        return null;
      });
  }

  function getCountry() {
    return fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return cart && cart.attributes ? cart.attributes[attributeName()] : undefined;
      });
  }

  function syncOnLoad() {
    if (!config || !config.country) return;

    var active = config.country;
    var saved = config.current;

    if (saved === active) {
      console.log(TAG, 'in sync:', attributeName() + '=' + saved);
      return;
    }

    console.log(TAG, 'out of sync (cart: ' + (saved || 'missing') + ', country: ' + active + '), updating...');
    setCountry(active);
  }

  /**
   * Header country selector: write the attribute, then continue with the normal localization submit.
   */
  function onSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || form.__storefrontCountryHandled) return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/localization') === -1) return;

    var submitter = event.submitter;
    var code = submitter && submitter.name === 'country_code' ? submitter.value : '';
    if (!code) return;

    event.preventDefault();
    form.__storefrontCountryHandled = true;

    console.log(TAG, 'country changed to ' + code + ', saving on cart before switching market...');
    remember('country switched to ' + code + ' -> cart ' + attributeName() + '=' + code);

    var finished = false;
    function continueSubmit() {
      if (finished) return;
      finished = true;

      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'country_code';
      hidden.value = code;
      form.appendChild(hidden);
      HTMLFormElement.prototype.submit.call(form);
    }

    setCountry(code).then(continueSubmit);
    window.setTimeout(continueSubmit, 2500);
  }

  function init() {
    config = parseConfig();
    replayLog();
    syncOnLoad();
  }

  document.addEventListener('submit', onSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.storefrontCountry = {
    get: getCountry,
    set: setCountry
  };
})();
